export enum ControlType {
  RADIO = 1,
  CHECKBOX = 2,
}
